import { userAxios } from '../../index'

/**
 * Servicio de planes y compra pública (member-plan checkout).
 */

/**
 * Obtiene todos los planes disponibles.
 * @returns {Promise}
 */
const getAllPlans = async () => {
  try {
    const response = await userAxios.get('get-plans/all')
    return response.data
  } catch (error) {
    console.error('Error al obtener los planes:', error)
    throw error
  }
}

/**
 * Registro público de agentes (Providers). No usar para compra de planes.
 * @param {Object} data
 * @returns {Promise}
 */
const registerUserPlan = async (data) => {
  try {
    const response = await userAxios.post('register-user-plan', data)
    return response.data
  } catch (error) {
    console.error('Error al registrar usuario con plan:', error)
    throw error
  }
}

/**
 * Lista agentes activos para el selector de compra (público).
 * GET /api/member-plan/agents
 * @returns {Promise<{ status: string, data: Array<{ id: number, name: string }> }>}
 */
const getMemberPlanAgents = async () => {
  try {
    const response = await userAxios.get('member-plan/agents')
    return response.data
  } catch (error) {
    console.error('Error al obtener agentes:', error)
    throw error
  }
}

/**
 * Inicia compra pública: crea sesión Stripe Checkout.
 * POST /api/member-plan/checkout
 * @param {Object} data
 * @param {string} data.name
 * @param {string} data.lastname
 * @param {string} data.phone
 * @param {string} data.email
 * @param {number} data.memberships_parameters_id
 * @param {string} [data.date_birth] MM-DD-YYYY (Senior)
 * @param {number|null} [data.agent_id]
 * @param {string} [data.billing_interval] month | quarter | year
 * @returns {Promise<{ status: string, data: { checkout_url: string, session_id: string, membership_id: number } }>}
 */
const createMemberPlanCheckout = async (data) => {
  try {
    const response = await userAxios.post('member-plan/checkout', data, {
      headers: { Accept: 'application/json' }
    })
    return response.data
  } catch (error) {
    console.error('Error al iniciar checkout de membresía:', error)
    throw error
  }
}

/**
 * Estado de la sesión de pago (página /plan-confirmado).
 * GET /api/member-plan/checkout/{session_id}
 * @param {string} sessionId
 * @returns {Promise<{ status: string, data: { state: string, plan_name?: string, email_hint?: string } }>}
 */
const getMemberPlanCheckoutSession = async (sessionId) => {
  try {
    const response = await userAxios.get(`member-plan/checkout/${encodeURIComponent(sessionId)}`, {
      headers: { Accept: 'application/json' }
    })
    return response.data
  } catch (error) {
    console.error('Error al consultar sesión de checkout:', error)
    throw error
  }
}

export default {
  getAllPlans,
  registerUserPlan,
  getMemberPlanAgents,
  createMemberPlanCheckout,
  getMemberPlanCheckoutSession
}
